import type { CSSProperties, FC, HTMLAttributes, ReactNode } from "react";

const visuallyHiddenStyle: CSSProperties = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};

interface VisuallyHiddenProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

const VisuallyHidden: FC<VisuallyHiddenProps> = ({
  children,
  style,
  ...props
}) => (
  <span style={{ ...visuallyHiddenStyle, ...style }} {...props}>
    {children}
  </span>
);

export default VisuallyHidden;
